<template>
  <v-app>
    <v-row>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <v-container fluid>
                <v-card-title>
                  <!--                  <v-spacer/>-->
                  <!--                  {{ $t($route.meta.title) }}-->
                  <!--                  <v-spacer/>-->

                  <!--                  <v-btn  :loading="loading" @click="getUserTransactions()" class="btn-update">-->
                  <!--                    <v-icon>mdi-refresh</v-icon>-->
                  <!--                    به روزرسانی-->
                  <!--                  </v-btn>-->
                </v-card-title>
                <v-divider />

                <div class="row">
                  <div class="col-md-12 p-5">
                    <data-table
                      :columns="columnTransactions"
                      :data="transactions"
                      :filters="filters"
                      :per-page="perPages"
                      :tableData="tableProps"
                      :translate="translates"
                      orderDir="desc"
                      @on-table-props-changed="reloadTable"
                    >
                      <template
                        slot="filters"
                        slot-scope="{ tableFilters, perPage }"
                      >
                        <div class="row mb-1">
                          <!--                          <div class="col-md-4">-->
                          <!--                            <select-->
                          <!--                                v-model="tableFilters.filters.type"-->
                          <!--                                class="form-control">-->
                          <!--                              <option value>نوع تراکنش</option>-->
                          <!--                              <option value='deposit'>افزایش</option>-->
                          <!--                              <option value='withdraw'>کسر</option>-->
                          <!--                            </select>-->
                          <!--                          </div>-->
                          <div class="col-md-6">
                            <select
                              v-model="tableFilters.filters.confirmed"
                              class="form-control"
                            >
                              <option value>همه ی وضعیت ها</option>
                              <option value="true">تایید شده</option>
                              <option value="false">تایید نشده</option>
                            </select>
                          </div>
                          <div class="col-md-6">
                            <date-picker
                              v-model="tableFilters.filters.date"
                              display-format="jYYYY-jMM-jDD"
                              format="YYYY-MM-DD"
                              label="تاریخ تراکنش"
                            />
                          </div>
                        </div>
                        <div class="row mb-2">
                          <div class="col-md-4">
                            <v-select
                              v-model="tableFilters.length"
                              :items="perPage"
                              dense
                              item-text="page"
                              item-value="page"
                              outlined
                            >
                            </v-select>
                          </div>
                          <div class="col-md-4">
                            <v-select
                              v-model="tableFilters.filters.admin_type"
                              :items="adminTypes"
                              clearable
                              dense
                              item-disabled="disabled"
                              item-text="value"
                              item-value="name"
                              outlined
                            >
                              <template slot="item" slot-scope="{ item }">
                                {{ item.value }}
                              </template>
                            </v-select>
                          </div>
                          <div class="col-md-4">
                            <v-text-field
                              v-model="tableFilters.search"
                              append-icon="search"
                              dense
                              label="جست وجو"
                              name="name"
                              outlined
                              placeholder="جست وجو"
                            ></v-text-field>
                          </div>
                        </div>
                      </template>
                    </data-table>

                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="tableProps.page"
                          label="برو به صفحه"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col>
                        <v-btn class="btn-list" @click="changePage">
                          <v-icon> mdi-numbers </v-icon>
                          <b>تغییر صفحه</b>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-container>
            </div>
          </div>
        </div>
      </div>
    </v-row>
    <v-dialog v-model="showDescription" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="text-h5">توضیحات مدیر</span>
          <v-spacer></v-spacer>
          <v-btn
            class="ml-1 text-danger"
            icon
            rounded
            small
            @click="showDescription = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <hr />
        <v-card-text>
          <br />
          <v-container>
            <v-row>
              <v-flex class="p-2" lg12 md12 sm12 xl12 xs12>
                <div
                  v-for="(item, index) in description.split('\n')"
                  :key="index"
                  class="text-center h5"
                >
                  {{ item }}
                </div>
                <br />
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Meta from "@/view/pages/transactions/Meta";

export default {
  name: "UserTransactions",
  data() {
    return {
      adminTypes: [
        { name: "online", value: "آنلاین" },
        { name: "admin", value: "توسط مدیر" },
        { name: "refund", value: "تراکنش اصلاحی" },
        { name: "agency", value: "عاملیت", disabled: true },
        { name: "withdraw", value: "برداشت" },
        { name: "deposit", value: "واریز" },
      ],
      filters: {
        type: "",
        admin_type: null,
        confirmed: "",
        date: "",
      },
      showDescription: false,
      description: "",
      transactionUrl: "transactions/user",
      tableProps: {
        search: "",
        page: 1,
        length: 10,
        filters: {
          type: "",
          admin_type: null,
          confirmed: "",
          date: "",
        },
        column: "id",
        dir: "desc",
      },
      transactions: {},
      loading: false,
      columnTransactions: [
        {
          label: "ردیف",
          transform: (val) => {
            let row = this.transactions.current_page - 1;
            row = row * this.transactions.per_page;
            return row + val.row + 1;
          },
        },
        {
          name: "id",
          label: "شناسه",
          orderable: true,
        },
        {
          name: "amount",
          label: "مبلغ(﷼)",
          orderable: true,
          transform: ({ data }) => {
            return data.type === "deposit"
              ? `<span class="badge badge badge-success">${this.persian(
                  this.$options.filters.rial(data.amount)
                )}</span>`
              : `<span class="badge badge badge-danger">${this.persian(
                  this.$options.filters.rial(data.amount)
                )}</span>`;
            // return this.persian(this.$options.filters.rial(value.data.amount));
          },
        },
        {
          label: "ساعت",
          name: "time",
          orderable: true,
          transform: (val) => {
            return this.persian(
              this.$options.filters.onlyTime(val.data.updated_at)
            );
          },
        },
        {
          label: "تاریخ",
          name: "updated_at",
          orderable: true,
          transform: (val) => {
            return this.persian(
              this.$options.filters.onlyDate(val.data.updated_at)
            );
          },
        },

        {
          label: "توضیحات تکمیلی",
          name: "description",
        },
        {
          name: "admin_type",
          label: "نوع تراکنش",
          component: Meta,
          handler: this.showMessage,
          event: "showMessage",
          meta: {
            type: "adminType",
          },
        },
        // {
        //   name: 'type',
        //   label: ' نوع تراکنش',
        //   transform: (value) => {
        //     return value.data.type === 'deposit'
        //         ? `<span class="badge badge badge-success">افزایش موجودی</span>`
        //         : `<span class="badge badge badge-danger">کسر موجودی</span>`
        //   }
        // },
        {
          name: "confirmed",
          label: "وضعیت",
          transform: (value) => {
            return value.data.confirmed === true
              ? `<span class="badge-pill badge badge-info">تایید شده</span>`
              : `<span class="badge-pill badge badge-danger">تایید نشده</span>`;
          },
        },
        {
          name: "comment",
          label: "توضیح",
          component: Meta,
          meta: {
            type: "comment",
          },
        },
        {
          name: "service",
          label: "نام سرویس",
          component: Meta,
          meta: {
            type: "service",
          },
        },
        {
          name: "remainMoney",
          label: "مانده موجودی",
          transform: ({ data }) => {
            return this.persian(this.$options.filters.rial(data.remainMoney));
          },
          // component: Meta,
          // meta: {
          //   type: 'actions'
          // }
        },
      ],
    };
  },
  created() {
    this.getUserTransactions(this.transactionUrl);
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },
  methods: {
    changePage() {
      if (this.tableProps.page === this.transactions.current_page)
        return this.$toast.info("شما در همین صفحه هستید!");
      this.getUserTransactions(this.url, this.tableProps);
    },
    showMessage(data) {
      this.showDescription = true;
      this.description = data.description;
    },
    getUserTransactions(url = this.transactionUrl, params = this.tableProps) {
      this.$modal.showLoading();
      this.requestApiGet(`${url}`, params).then((response) => {
        this.transactions = response.data;
        this.loading = false;
        this.$modal.hideLoading();
      });
    },
    reloadTable(tableProps) {
      this.getUserTransactions(this.transactionUrl, tableProps);
    },
  },
};
</script>

<style scoped></style>
